import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { HiArrowRight } from 'react-icons/hi'

const Card = ({ project, index }) => {
  const [imgLoaded, setImgLoaded] = useState(false)
  const [hovered, setHovered] = useState(false)
  const { _id, title, details, subTitle, gallery } = project
  const navigate = useNavigate()

  const goToProject = (e) => {
    // don't navigate if user clicked the photo lightbox trigger
    if (e.target.closest('[data-photo-view]')) return
    navigate(`/project/${_id}`)
  }

  return (
    <div
      onClick={goToProject}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative',
        borderRadius: '14px',
        border: hovered
          ? '1px solid rgba(250,204,21,0.6)'
          : '1px solid rgba(250,204,21,0.13)',
        background: hovered
          ? 'linear-gradient(145deg, rgba(250,204,21,0.09), rgba(8,8,14,0.95))'
          : 'linear-gradient(145deg, rgba(255,255,255,0.04), rgba(8,8,14,0.85))',
        boxShadow: hovered
          ? '0 0 32px rgba(250,204,21,0.2), 0 12px 40px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.07)'
          : '0 0 14px rgba(250,204,21,0.06), 0 4px 16px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.04)',
        transform: hovered ? 'scale(1.03) translateY(-6px)' : 'scale(1)',
        transition: 'all 0.34s cubic-bezier(0.34,1.56,0.64,1)',
        padding: '18px',
        overflow: 'hidden',
        cursor: 'pointer',
        animation: `fadeSlideUp 0.4s ease both`,
        animationDelay: `${(index ?? 0) * 0.08}s`,
      }}
    >
      {/* top shimmer sweep */}
      <div style={{
        position: 'absolute', top: 0,
        left: hovered ? '110%' : '-55%',
        width: '45%', height: '2px',
        background: 'linear-gradient(90deg, transparent, rgba(250,204,21,0.9), transparent)',
        transition: 'left 0.5s ease',
      }} />

      {/* image — click opens lightbox, stops card navigation */}
      <PhotoProvider>
        <div data-photo-view onClick={(e) => e.stopPropagation()}>
          <PhotoView src={gallery[0]}>
            <img
              src={gallery[0]}
              alt={title}
              onLoad={() => setImgLoaded(true)}
              style={{
                width: '100%',
                height: '148px',
                objectFit: 'cover',
                borderRadius: '8px',
                display: 'block',
                marginBottom: '16px',
                filter: !imgLoaded
                  ? 'blur(4px)'
                  : hovered
                  ? 'grayscale(0%) brightness(1.05) drop-shadow(0 4px 12px rgba(250,204,21,0.2))'
                  : 'grayscale(35%) brightness(0.8)',
                transition: 'filter 0.38s ease',
                cursor: 'zoom-in',
              }}
            />
          </PhotoView>
        </div>
      </PhotoProvider>

      {/* content */}
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '150px' }}>
        <div>
          <p style={{
            color: hovered ? '#facc15' : '#c4c4c4',
            fontWeight: 700,
            fontSize: '1.15rem',
            lineHeight: 1.2,
            marginBottom: '6px',
            textShadow: hovered ? '0 0 16px rgba(250,204,21,0.4)' : 'none',
            transition: 'color 0.3s ease, text-shadow 0.3s ease',
          }} title={title}>
            {title?.length > 20 ? title.slice(0, 18) + '…' : title}
          </p>
          <p style={{ color: hovered ? '#e2e8f0' : '#6b7280', fontSize: '0.85rem', marginBottom: '10px', transition: 'color 0.3s ease' }}>
            {subTitle}
          </p>
          <p style={{ color: hovered ? '#94a3b8' : '#4b5563', fontSize: '0.8rem', lineHeight: 1.6, transition: 'color 0.3s ease' }}>
            {details?.length > 100 ? details.slice(0, 60) + '…' : details}
          </p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: '14px', gap: '6px' }}>
          <span style={{
            color: hovered ? '#facc15' : '#555',
            fontSize: '10px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: hovered ? '0.18em' : '0.1em',
            transition: 'all 0.3s ease',
          }}>
            View Details
          </span>
          <HiArrowRight style={{
            color: hovered ? '#facc15' : '#555',
            fontSize: '13px',
            transform: hovered ? 'translateX(3px)' : 'translateX(0)',
            transition: 'all 0.3s ease',
          }} />
        </div>
      </div>
    </div>
  )
}

export default Card
